"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkeletonLoading = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const SkeletonLoading = (props) => {
    const { width = '100%', height } = props;
    return react_1.default.createElement(styles_1.MovingGradient, { height: height, width: width });
};
exports.SkeletonLoading = SkeletonLoading;
